import React from "react";

const Preloader = ({ loading }) => {
  if (!loading) return null;

  return (
    <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(255, 255, 255, 0.35)",
      backdropFilter: "blur(6px) saturate(1.4)",
      WebkitBackdropFilter: "blur(6px) saturate(1.4)",
      zIndex: 9999,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 16,
    }}>
      {/* Spinner ring */}
      <div style={{
        width: 48,
        height: 48,
        borderRadius: "50%",
        border: "4px solid #E8F5E9",
        borderTopColor: "#2E7D32",
        animation: "preloader-spin 0.75s linear infinite",
      }} />

      <span style={{
        fontSize: 13,
        fontWeight: 600,
        color: "#2E7D32",
        letterSpacing: 0.5,
      }}>
        Loading…
      </span>

      <style>{`
        @keyframes preloader-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Preloader;
